export default __webpack_public_path__ + "static/brand-2e2c73bf27166863e0ae824dcac5f9a4.svg";